import styled, { keyframes } from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  textBoxTrim
} from '@dboxdev/ui-components'

export const Wrapper = styled.div`
  position: relative;
`

export const HeroWrapper = styled.section`
  position: relative;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 1.4s ease-in-out 0.1s;
  ${mediaMax('mobile')} {
    height: 100dvh;
    padding: 6vh 0 0 0;
    background: #758592;
  }
`

export const HeroLogoMobile = styled.div`
  display: none;
  ${mediaMax('mobile')} {
    display: block;
    width: ${calculateResponsiveSize(185)};
    margin: 0 auto 2vh auto;
    color: #ffffff;
    svg {
      display: block;
      width: 100%;
      height: auto;
    }
  }
`

export const HeroCopyMobile = styled.div`
  display: none;
  ${mediaMax('mobile')} {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 4.46vh 0 0 0;
    position: relative;
  }
`

const copyFadeInOut = keyframes`
  0%    { opacity: 0; }
  5.7%  { opacity: 1; }
  9.4% { opacity: 1; }
  15.1% { opacity: 0; }
  100%  { opacity: 0; }
`

export const HeroCopy = styled.h2`
  ${mediaMax('mobile')} {
    position: absolute;
    top: 0;
    margin: 0;
    text-align: center;
    font-family: var(--font-secondary);
    font-size: ${calculateResponsiveSize(26)};
    color: #ffffff;
    line-height: 1.1;
    font-weight: 280;
    letter-spacing: ${calculateResponsiveSize(0.177)};
    text-transform: uppercase;
    opacity: 0;
    animation: ${copyFadeInOut} 20.907s linear infinite;
    animation-play-state: paused;
    ${HeroCopyMobile}[data-playing='true'] & {
      animation-play-state: running;
    }
    &.video-copy-1 { animation-delay: 1.8s; }
    &.video-copy-2 { animation-delay: 6s; }
    &.video-copy-3 { animation-delay: 9.5s; }
    &.video-copy-4 { animation-delay: 13.5s; }
    &.video-copy-5 { animation-delay: 16.5s; }
  }
`

export const ArrowDown = styled.div`
  position: absolute;
  left: 50%;
  bottom: ${calculateResponsiveSize(32)};
  width: ${calculateResponsiveSize(76.476)};
  color: #ffffff;
  transform: translateX(-50%);
  cursor: pointer;
  z-index: 2;
  svg {
    display: block;
    width: 100%;
    height: auto;
  }
  ${mediaMax('mobile')} {
    top: 80.634vh;
    bottom: auto;
    width: ${calculateResponsiveSize(50)};
  }
`

export const FilmsWrapper = styled.section`
  display: flex;
  height: 100vh;
  min-height: ${calculateResponsiveSize(1080)};
  background: #000000;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 1.4s ease-in-out 0.1s;
  overflow: hidden;
  ${mediaMax('mobile')} {
    flex-direction: column;
    height: auto;
    min-height: auto;
  }
`

export const FilmsCol = styled.div`
  width: 50%;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  &:last-child {
    width: calc(50% + 1px);
    margin: 0 0 0 -1px;
  }
  ${mediaMax('mobile')} {
    width: 100% !important;
    margin: 0 !important;
    height: ${calculateResponsiveSize(440)};
  }
`

export const FilmContent = styled.div`
  position: absolute;
  top: 66.2%;
  left: 0;
  right: 0;
  text-align: center;
  color: #ffffff;
  z-index: 4;
  ${mediaMax('mobile')} {
    top: auto;
    bottom: ${calculateResponsiveSize(50)};
  }
`

export const FilmTitle = styled.h2`
  ${textBoxTrim}
  margin: 0 0 ${calculateResponsiveSize(80)};
  font-family: var(--font-secondary);
  font-size: ${calculateResponsiveSize(48)};
  font-weight: 280;
  line-height: 1.1;
  letter-spacing: ${calculateResponsiveSize(1.344)};
  text-transform: uppercase;
  ${mediaMax('mobile')} {
    width: ${calculateResponsiveSize(290)};
    margin: 0 auto ${calculateResponsiveSize(31)};
    font-size: ${calculateResponsiveSize(30)};
    letter-spacing: ${calculateResponsiveSize(0.546)};
  }
`

export const FilmCopy = styled.div`
  ${textBoxTrim}
  margin: 0 0 ${calculateResponsiveSize(35)};
  font-family: var(--font-primary);
  font-size: ${calculateResponsiveSize(20)};
  font-weight: 300;
  line-height: 1.2;
  letter-spacing: ${calculateResponsiveSize(0.5)};
  text-transform: uppercase;
  ${mediaMax('mobile')} {
    margin: 0 0 ${calculateResponsiveSize(18)};
    font-size: ${calculateResponsiveSize(11)};
    letter-spacing: ${calculateResponsiveSize(0.203)};
  }
`

export const FilmDescription = styled.div`
  ${textBoxTrim}
  width: ${calculateResponsiveSize(580)};
  ${FilmsCol}:first-child & {
    width: ${calculateResponsiveSize(660)};
  }
  margin: 0 auto;
  font-family: var(--font-primary);
  font-size: ${calculateResponsiveSize(20)};
  font-weight: 300;
  line-height: 1.2;
  letter-spacing: ${calculateResponsiveSize(0.5)};
  ${mediaMax('mobile')} {
    width: ${calculateResponsiveSize(338)};
    ${FilmsCol}:first-child & {
      width: ${calculateResponsiveSize(332)};
    }
    font-size: ${calculateResponsiveSize(11)};
    letter-spacing: ${calculateResponsiveSize(0.203)};
  }
`

export const FilmImage = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  &::after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    content: '';
    background: rgba(0, 0, 0, 0.4);
    transition: background 0.5s ease-in-out;
    z-index: 2;
  }
  & .gatsby-image-wrapper {
    height: 100%;
    transform: scale(1.05);
    transition: transform 0.5s ease-in-out;
  }
  ${FilmsCol}:hover &{
    &::after {
      background: rgba(0, 0, 0, 0.2);
    }
    & .gatsby-image-wrapper {
      transform: scale(1);
    }
  }
`

export const PlayIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: ${calculateResponsiveSize(96.171)};
  color: #ffffff;
  transform: translate(-50%, -50%);
  z-index: 3;
  svg {
    display: block;
    width: 100%;
    height: auto;
  }
  ${mediaMax('mobile')} {
    top: ${calculateResponsiveSize(148)};
    ${FilmsCol}:first-child & {
      top: ${calculateResponsiveSize(168)};
    }
    width: ${calculateResponsiveSize(40)};
    transform: translate(-50%, 0%);
  }
`
